var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 6.25c9.803 0 17.75 7.947 17.75 17.75S33.803 41.75 24 41.75 6.25 33.803 6.25 24 14.197 6.25 24 6.25zm0 3.5C16.13 9.75 9.75 16.13 9.75 24S16.13 38.25 24 38.25 38.25 31.87 38.25 24 31.87 9.75 24 9.75zm-2.799 20.454l-5.169-5.17a.8.8 0 010-1.13l1.272-1.272a.8.8 0 011.132 0l3.331 3.331 6.73-6.73a.8.8 0 011.132 0l1.272 1.271a.8.8 0 010 1.132l-8.568 8.568a.8.8 0 01-1.132 0z",
    id: "complete_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "complete_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#complete_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#complete_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#complete_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTI0IDYuMjVjOS44MDMgMCAxNy43NSA3Ljk0NyAxNy43NSAxNy43NVMzMy44MDMgNDEuNzUgMjQgNDEuNzUgNi4yNSAzMy44MDMgNi4yNSAyNCAxNC4xOTcgNi4yNSAyNCA2LjI1em0wIDMuNUMxNi4xMyA5Ljc1IDkuNzUgMTYuMTMgOS43NSAyNFMxNi4xMyAzOC4yNSAyNCAzOC4yNSAzOC4yNSAzMS44NyAzOC4yNSAyNCAzMS44NyA5Ljc1IDI0IDkuNzV6bS0yLjc5OSAyMC40NTRsLTUuMTY5LTUuMTdhLjguOCAwIDAgMSAwLTEuMTNsMS4yNzItMS4yNzJhLjguOCAwIDAgMSAxLjEzMiAwbDMuMzMxIDMuMzMxIDYuNzMtNi43M2EuOC44IDAgMCAxIDEuMTMyIDBsMS4yNzIgMS4yNzFhLjguOCAwIDAgMSAwIDEuMTMybC04LjU2OCA4LjU2OGEuOC44IDAgMCAxLTEuMTMyIDB6IiBpZD0iYSIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjx1c2UgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNhIi8+PGcgbWFzaz0idXJsKCNiKSIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJNMCAwaDQ4djQ4SDB6Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgComplete as ReactComponent };